import { render, staticRenderFns } from "./graph_triple_panel.vue?vue&type=template&id=38f2711c&scoped=true"
import script from "./graph_triple_panel.vue?vue&type=script&lang=js"
export * from "./graph_triple_panel.vue?vue&type=script&lang=js"
import style0 from "./graph_triple_panel.vue?vue&type=style&index=0&id=38f2711c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2711c",
  null
  
)

export default component.exports